import { render } from "./TheMyCollectionMain.vue?vue&type=template&id=f0fa6d20&scoped=true&ts=true"
import script from "./TheMyCollectionMain.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionMain.vue?vue&type=script&lang=ts"

import "./TheMyCollectionMain.vue?vue&type=style&index=0&id=f0fa6d20&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0fa6d20"]])

export default __exports__